import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@parashift/shared/services';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const status = error?.status as any;
      if (status === 401 || status === 'unauthorized') {
        // A 401 on the tenant-bearer mint (/me/bearer?tenant_id=X) means that tenant needs step-up:
        // forward its id so id-api routes to the missing login step. Any other 401 → plain re-login.
        const tenantId = bearerMintTenantId(req);
        tenantId ? authService.login(false, tenantId) : authService.login();
      }
      return throwError(() => error);
    })
  );
};

function bearerMintTenantId(req: HttpRequest<unknown>): string | undefined {
  try {
    const { pathname, searchParams } = new URL(req.urlWithParams, window.location.origin);
    return pathname.endsWith('/me/bearer') ? (searchParams.get('tenant_id') ?? undefined) : undefined;
  } catch {
    return undefined;
  }
}
